import apiUtils from "../../utils/apiFeatures";

export default function HrAPI() {
  const { fetchData, postData, putData } = apiUtils();

  const getAllEmployee = () => fetchData("employee");
  const getAllBranch = () => fetchData("employee/branch");
  const registerBranch = (data) => postData("employee/branch/register", data);
  const updateBranch = (data) => putData(`employee/branch/update`, data);
  const getAllGrade = () => fetchData("employee/grade");

  return {
    getAllEmployee,
    getAllBranch,
    registerBranch,
    updateBranch,
    getAllGrade,
  };
}
